import { ScreenOption } from "../ScreenOption";
import { useAppSelector } from "../../../Redux/store";

interface IProps {
    options: Array<string>;
    fullWidth?: boolean;
}

export const ScreenOptionsManager: React.FC<IProps> = ({options, fullWidth}) => {
    const { optionSelected } = useAppSelector(state => state.screenInteractions);

    return (
        <>
            {options.map((o, i) => { 
                return (
                        <ScreenOption 
                            text={o} 
                            selected={optionSelected === i} 
                            key={i} 
                            fullWidth={fullWidth}
                        />
                    )
                }
            )}
        </>
    );
}